// removed by extract-text-webpack-plugin
module.exports = {"Guides__heading":"src-components-guides----guides-module---Guides__heading---VoZD4","Guide":"src-components-guides----guides-module---Guide---1bPF7","Guide__img":"src-components-guides----guides-module---Guide__img---zNEi0","Guide__heading":"src-components-guides----guides-module---Guide__heading---34PI2","spinAround":"src-components-guides----guides-module---spinAround---4f5x8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/guides/guides.module.scss
// module id = 288
// module chunks = 35783957827783